import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/common/ReadMore.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/style/EduPages.scss");
